/*
 * Native Possum — np-gift-card.js
 * The gift card page (sections/main-product-gift-card.liquid): amount pills, the
 * "I'm buying this for myself" switch, the message counter, and Add to Bag.
 * Add to bag submits #gcForm through npCart. The recipient fields belong to that form
 * (form="gcForm"), so what the shopper typed is what is sent — at any screen width.
 * Shopify delivers the card by the properties[__recipient_*] fields; the visible copies
 * (Recipient Email / Recipient Name / Message) show at checkout and on the order.
 */
(function() {
  'use strict';

  var form = document.getElementById('gcForm');
  if (!form) return;

  var pills = Array.prototype.slice.call(document.querySelectorAll('.gc-denomination-btn'));
  var stickyPrice = document.getElementById('gcStickyPrice');
  var selfPurchase = document.getElementById('gcSelfPurchase');
  var fields = document.getElementById('gcRecipientFields');
  var message = document.getElementById('gcRecipientMessage');
  var counter = document.getElementById('gcCharCount');
  var recipientInputs = fields ? Array.prototype.slice.call(fields.querySelectorAll('input, textarea')) : [];

  // ---- Amount ----
  pills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      pills.forEach(function(p) {
        var on = p === pill;
        p.classList.toggle('selected', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      form.elements.id.value = pill.getAttribute('data-variant-id');
      if (stickyPrice) stickyPrice.textContent = pill.getAttribute('data-display-price');
    });
  });

  // ---- Message counter ----
  function updateCounter() {
    if (!message || !counter) return;
    var len = message.value.length;
    counter.textContent = len + ' / 200';
    counter.classList.toggle('at-limit', len >= 200);
  }
  if (message) message.addEventListener('input', updateCounter);

  // ---- Buying for myself: no recipient fields (disabled fields aren't sent) ----
  if (selfPurchase && fields) {
    selfPurchase.addEventListener('change', function() {
      var mine = selfPurchase.checked;
      fields.classList.toggle('is-hidden', mine);
      recipientInputs.forEach(function(input) {
        if (mine) input.value = '';
        input.disabled = mine;
      });
      updateCounter();
    });
  }

  // ---- Errors: before the Add to Bag button, or under the amounts on a phone ----
  function showError(message, quiet) {
    document.querySelectorAll('.gc-error-message').forEach(function(el) { el.remove(); });
    var box = document.createElement('div');
    box.className = 'gc-error-message';
    if (!quiet) box.setAttribute('role', 'alert');
    box.textContent = message;
    var button = document.getElementById('gcAddToBag');
    var amounts = document.querySelector('.gc-denomination-section');
    if (button && button.getClientRects().length) button.insertAdjacentElement('beforebegin', box);
    else if (amounts) amounts.insertAdjacentElement('afterend', box);
    else if (button) button.insertAdjacentElement('beforebegin', box);
    window.npMessage.hold(box, function() { box.remove(); });
  }

  // ---- Add to bag ----
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    document.querySelectorAll('.gc-error-message').forEach(function(el) { el.remove(); });

    if (!form.elements.id.value) {
      showError('Please select an amount');
      return;
    }

    var data = new FormData(form);
    var forSomeoneElse = !(selfPurchase && selfPurchase.checked);
    if (forSomeoneElse) {
      var email = String(data.get('properties[__recipient_email]') || '').trim();
      if (!email || email.indexOf('@') === -1) {
        showError('Please enter a valid recipient email address');
        return;
      }
      var name = String(data.get('properties[__recipient_name]') || '').trim();
      var note = String(data.get('properties[__recipient_message]') || '').trim();
      data.set('properties[__recipient_email]', email);
      data.append('properties[Recipient Email]', email);
      if (name) {
        data.set('properties[__recipient_name]', name);
        data.append('properties[Recipient Name]', name);
      } else {
        data.delete('properties[__recipient_name]');
      }
      if (note) {
        data.set('properties[__recipient_message]', note);
        data.append('properties[Message]', note);
      } else {
        data.delete('properties[__recipient_message]');
      }
    }

    var buttons = [document.getElementById('gcAddToBag'), document.getElementById('gcStickyAdd')].filter(Boolean);
    var trigger = e.submitter || buttons.filter(function(b) { return b.getClientRects().length; })[0] || null;
    // npCart: one queue, busy state (no double add), opens the bag, announces both outcomes
    window.npCart.add(data, { control: buttons, trigger: trigger }).catch(function(error) {
      showError((error && error.message) || 'Error adding to bag. Please try again.', true);
    });
  });
})();
